import React from "react"
const MoustacheActiveIcon = ({ size, className }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<rect width="40" height="40" rx="20" fill="#DDE3EE" />
			<path
				d="M12.9921 27.9549V12.0472C12.9921 11.6789 13.3877 11.6789 13.3877 11.6789H14.5V9.5H12.8829C12.8829 9.5 10.6538 9.5 10.6538 11.5752V18.586C10.6385 18.7854 10.4419 18.7997 10.4025 18.7997H9.5V21.1861H10.4025C10.5992 21.1861 10.6451 21.3163 10.6538 21.4018V28.4248C10.6538 28.4248 10.6538 30.5 12.8829 30.5H14.5V28.3231H13.3877C12.9921 28.3231 12.9921 27.9549 12.9921 27.9549Z"
				fill="#0A0A0A"
			/>
			<path
				d="M26.3133 9.5H15.5V11.6437H19.5231C19.784 11.6437 19.7938 11.8937 19.7938 11.9217V23.498H21.8131V11.9217C21.8131 11.6537 22.0565 11.6437 22.0838 11.6437H25.9121C26.9715 11.6437 27.7212 12.0816 28.1457 12.9475C28.465 13.5994 28.4689 14.2633 28.4689 14.2693V23.5H30.5V13.8034C30.5019 13.7594 30.4552 9.5 26.3133 9.5Z"
				fill="#0A0A0A"
			/>
		</svg>
	)
}
export default MoustacheActiveIcon
